import type { ValidationErrors } from "./PeriodBasedTable.types";

export const EMPTY_DATE_PLACEHOLDER = "-";
export const EMPTY_ERRORS: ValidationErrors = {};
